export default __webpack_public_path__ + "static/media/iconfont.4e9cb330.ttf";